import React from 'react';

/**
 * Eyebrow — voix de label unique (DESIGN-SPEC §3.3).
 *
 * Petit label éditorial « sceau » précédé d'un filet hairline.
 * Remplace les pills plates bg-teal-100 et le point pulsant.
 *
 * Rendu : inline-flex items-center gap-2 text-xs font-semibold uppercase
 *         tracking-[0.18em] text-slate-400, précédé d'un filet h-px w-6 bg-teal-700/40.
 *
 * Props :
 *  - children : contenu textuel du label (toujours fourni par la config, language-agnostic).
 *  - as       : "span" | "div" (def "span").
 *  - className : classes additionnelles.
 */
export default function Eyebrow({ children, as = 'span', className = '' }) {
  const Tag = as;
  return (
    <Tag
      className={
        'inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-slate-400' +
        (className ? ` ${className}` : '')
      }
    >
      <span aria-hidden="true" className="h-px w-6 bg-teal-700/40" />
      {children}
    </Tag>
  );
}
